import { configureStore, applyMiddleware } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";
import rootReducer from "../reducers";

const middleware = [thunk];
const composedEnhancer = composeWithDevTools(applyMiddleware(...middleware));
const store = configureStore({ reducer: rootReducer }, composedEnhancer);
export default store;
